import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { IActionButton } from './Type';

const ActionButton = (props: IActionButton) => {
  const {title, icon, onClick, disabled} = props;
  return (<>
    <Tooltip PopperProps={{
      disablePortal: true
    }} title={title}>
      <IconButton size='large'
        onClick={onClick}
        disabled={disabled}
      >
        {icon}
      </IconButton>
    </Tooltip>
  </>
  );
};

export default ActionButton;
